if (!customElements.get('tab-group')) {
  class TabGroup extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('.tab').forEach(tab => {
        tab.addEventListener('click', () => {
          this.querySelectorAll('.content').forEach(content => {
            content.classList.remove('active');
          });
          
          const targetContent = this.querySelector(`#${tab.getAttribute('data-target')}`);
          targetContent.classList.add('active');
        });
      });
    }
  }

  customElements.define('tab-group', TabGroup);
}
